module.exports = __webpack_public_path__ + "img/carousel-barilla.png?4319e66ed760da45176a5800d16a3b16";